import { Suspense, lazy } from 'react';

import type { MapProviderProps } from './types';

// react-map-gl + @math.gl + gl-matrix are ~30 modules only a handful of screens
// need, so they stay out of the shared ui chunk.
const MapLazy = lazy(() => import('./Map'));

const Map = (props: MapProviderProps) => (
  <Suspense fallback={null}>
    <MapLazy {...props} />
  </Suspense>
);

export default Map;
